import * as yup from 'yup'

export default yup.object().shape({
  billing: yup.object().shape({
    entity: yup.string(),
    payment: yup.object().shape({
      accountHolder: yup.string(),
      sortCode: yup.string(),
      accountNumber: yup.string(),
    }),
    billingTermTypeName: yup.string(),
    billingTermValue: yup.number(),
    vatNumber: yup.string(),
    vatRegistered: yup.boolean(),
    address: yup.object().shape({
      addressLine1: yup.string(),
      addressLine2: yup.string(),
      addressLine3: yup.string(),
      town: yup.string(),
      county: yup.string(),
      postCode: yup.string(),
      country: yup.string(),
      countryCode: yup.string(),
    }),
    contact: yup.object().shape({
      name: yup.string(),
      email: yup.string(),
      contactNumber: yup.string(),
    }),
  }),
})
